<template>
  <div>
    <div v-if="item" v-disable-all="isReadonly">
      <div class="row my-3">

        <div class="col  col-md-12">
          <div class="form-group required">
            <div class="form-group required">
              <label class="control-label">Наименование услуги</label>
              <Select2
                  class="select2"
                  :options="vacancyServiceTypeList"
                  :settings="select2Settings"
                  v-model="item.vacancyServiceTypeId"
                  style="width: 100%"
              />
              <div class="invalid-msg" v-if="v$.item.vacancyServiceTypeId.$error">Поле обязательно для заполнения</div>
            </div>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата заявления</label>
            <date-component :disabled="isReadonly" v-model="item.dateApplicant" :required="true"/>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата оказания</label>
            <date-component :disabled="isReadonly" v-model="item.dateResult" :required="true"/>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <component-input
                label="Результат оказания"
                v-model="item.result"
                required/>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="float-right d-flex align-items-center">
        <button-component class="btn btn-primary mx-2" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
        <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть</button-component>
      </div>
    </div>
  </div>
</template>
<script>
import API from '../api/applicantService'
import Constants from '../../../common/constants'
import {required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import ButtonComponent from "../../../common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import Utils from "@/common/utils";
import disableAll from "@/common/directives/disable-all";

const selectValidator = (value) => value > 0;

export default {
  name: "ApplicantHistoryCard",
  components: {
    ButtonComponent,
    DateComponent,
    ComponentInput
  },
  directives: {
    'disable-all': disableAll
  },
  props: {
    applicantId: Number,
    cardId: {
      type: Number,
      required: false,
      default: null
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loadVacancyServiceTypeList();
    this.loadPage();
  },
  data() {
    return {
      item: {
        applicantId: 0,
        dateApplicant: null,
        dateResult: null,
        vacancyServiceTypeId: 0,
      },
      vacancyServiceTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ]
    };
  },
  methods: {
    loadVacancyServiceTypeList() {
      Utils.loadSelectOptions(
          "vacancyServiceType",
          this.vacancyServiceTypeList);
    },
    loadPage() {
      var self = this;
      if (self.cardId) {
        API.find(self.cardId).then(response => {
          self.item = response.data;
        });
      } else {
        self.item.applicantId = self.applicantId;
      }
    },
    save() {
      var self = this;

      self.v$.$touch();
      if (self.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      API.save(self.item).then(function (response) {
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          self.$emit('save');
        }
      });
    },
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        vacancyServiceTypeId: {required, selectValidator}
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
</style>